import React from "react"
import EvResultUIComp from "./evresult"
import Pace from "../../components/pace"
import "./style.scss"

const EvInputUIComp = (props) => (
  <div className="d-flex flex-column align-items-center justify-content-center ">
    <div className="row-input">
      <div className="d-flex ev-input-container">
        <input
          className={"ev-input bg-light"}
          maxLength={120}
          type="text"
          placeholder={props.placeholder}
          ref={props.emailInputEleRef}
          onKeyUp={props.onEmailInputEleKeyUp}
        ></input>
        <button
          ref={props.buttonEleRef}
          className={
            !props.enableSubmitButton
              ? "btn btn-primary ev-button disabled"
              : "btn btn-primary ev-button"
          }
          onKeyUp={props.onButtonEleKeyUp}
          onClick={props.onButtonEleClick}
        >
          {props.isExecuting ? "Validating.." : "Validate"}
        </button>
      </div>
      <div className="ev-progressbar-container">
        {props.isExecuting ? (
          <Pace height={3} className={"ev-progressbar"} initialWidth={0.3} isExecuting={props.isExecuting} />
        ) : null}
      </div>
    </div>
    <div className="row-output">
      {props.evResponse ? <EvResultUIComp evResult={props.evResponse} /> : null}
    </div>
  </div>
)

export default EvInputUIComp
